var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.514715 10.4999C0.514715 10.1236 0.658418 9.74726 0.945221 9.46032L9.97484 0.430797C10.5492 -0.143599 11.4805 -0.143599 12.0547 0.430797C12.6288 1.00496 12.6288 1.93606 12.0547 2.5105L4.06478 10.4999L12.0544 18.4894C12.6286 19.0638 12.6286 19.9948 12.0544 20.5689C11.4802 21.1436 10.549 21.1436 9.97456 20.5689L0.944942 11.5396C0.658092 11.2525 0.514715 10.8762 0.514715 10.4999Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.063ac2624c592d087e92825552990f41.svg";
export { ForwardRef as ReactComponent };